module.exports = __webpack_public_path__ + "img/Sylva.8e2b1758.png";